import Exception from "@/core/exceptions/Exception";
import DefaultExceptionTypes from "@/core/exceptions/DefaultExceptionTypes";
import { AccountsOverviewResponse } from "@/core/customers/entities/Accounts";
import AccountsRepository from "@/core/customers/repositories/AccountsRepository";

export default class GetAccountsOverviewUseCase {
  constructor(private readonly accountsRepository: AccountsRepository) {}

  /**
   * Executes the get accounts overview use case.
   *
   * @param businessKey - The business key of the customer
   * @returns A promise resolving with AccountsOverviewResponse
   * @throws {Exception} If an exception occurs during execution
   */
  async execute(businessKey: string): Promise<AccountsOverviewResponse> {
    if (!businessKey || businessKey.trim() === "") {
      const exception: Exception<unknown, DefaultExceptionTypes> = {
        type: DefaultExceptionTypes.BAD_REQUEST,
        message: "Business key is required",
      };
      throw exception;
    }

    try {
      return await this.accountsRepository.getAccountsOverview(businessKey);
    } catch (e) {
      if ((e as Exception).type) {
        throw e;
      } else {
        throw { type: DefaultExceptionTypes.UNKNOWN_ERROR, body: e };
      }
    }
  }
}

